import { useState } from "react";
import { Row, Col, Button, Modal, Space, Divider, Input, Form } from "antd";
import { PushpinOutlined, AimOutlined, EditOutlined, CompassOutlined, SwapOutlined, GlobalOutlined, SaveOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { MapaUbicacion } from "../MapaUbicacion/MapaUbicacion";
import { useOrigenDestino } from "./useOrigenDestino";
import { CLIENTES_IDS } from "../../../../constants/cons";
import { UbicacionCard } from "./UbicacionCard";

export const FormularioOrigenDestino = ({ asistenciaID, onGuardado }) => {
  const { captura } = useSelector((state) => state.asistenciasReducer);
  const esGS = captura.campaniaID == CLIENTES_IDS.GS_DEV || captura.campaniaID == CLIENTES_IDS.GS_PROD;

  const [modalOrigenVisible, setModalOrigenVisible] = useState(false);
  const [modalDestinoVisible, setModalDestinoVisible] = useState(false);

  const {
    datosOrigen,
    datosDestino,
    ubicacionRecibida,
    requiereDestino,
    referenciaVisualOrigen,
    setReferenciaVisualOrigen,
    loadingGuardar,
    loadingGeocode,
    puedeGuardar,
    esperandoSMS,
    enviarWhatsApp,
    actualizarOrigen,
    actualizarDestino,
    guardarUbicaciones,
  } = useOrigenDestino(asistenciaID);


  const handleOrigenChange = (direccionData) => {
    actualizarOrigen(direccionData);
    setModalOrigenVisible(false);
  };

  const handleDestinoChange = (direccionData) => {
    actualizarDestino(direccionData);
    setModalDestinoVisible(false);
  };

  const handleGuardar = async () => {
    const result = await guardarUbicaciones()
    if (result?.success && onGuardado) onGuardado()
  }

  return (
    <div style={{ width: '100%' }}>
      {/* Cards de Origen y Destino */}
      <Row gutter={[16, 16]}>
        <Col xs={24} md={requiereDestino ? 12 : 24}>
          <UbicacionCard
            titulo="Origen"
            icono={<PushpinOutlined />}
            datos={datosOrigen}
            onVerMapa={() => setModalOrigenVisible(true)}
            onChange={actualizarOrigen}
            iconoAccion={<EditOutlined />}
            iconoVacio={<GlobalOutlined />}
            textoVacio="Sin ubicación de origen"
          />
        </Col>
        {requiereDestino && (
          <Col xs={24} md={12}>
            <UbicacionCard
              titulo="Destino"
              icono={<AimOutlined />}
              datos={datosDestino}
              onVerMapa={() => setModalDestinoVisible(true)}
              onChange={actualizarDestino}
              iconoAccion={<SwapOutlined />}
              iconoVacio={<CompassOutlined />}
              textoVacio="Sin ubicación de destino"
            />
          </Col>
        )}
      </Row>

      <Divider />

      {/* Referencia visual y guardar */}
      <Row gutter={[16, 16]} align="bottom">
        <Col xs={24} sm={16}>
          <Form layout="vertical">
            <Form.Item label="Referencia visual del origen" style={{ marginBottom: 0 }}>
              <Input
                size="large"
                value={referenciaVisualOrigen}
                onChange={(e) => setReferenciaVisualOrigen(e.target.value)}
                placeholder="Ej. Frente al parque, esquina con calle..."
              />
            </Form.Item>
          </Form>
        </Col>
        <Col xs={24} sm={8}>
          <Button
            type="primary"
            icon={<SaveOutlined />}
            block
            size="large"
            onClick={handleGuardar}
            loading={loadingGuardar || loadingGeocode}
            disabled={!puedeGuardar}
          >
            Guardar Ubicación
          </Button>
        </Col>
      </Row>

      {/* Modal Origen */}
      <Modal
        title={<Space><PushpinOutlined /><span>Seleccionar Ubicación de Origen</span></Space>}
        open={modalOrigenVisible}
        onCancel={() => setModalOrigenVisible(false)}
        footer={null}
        width={800}
        destroyOnClose
      >
        <MapaUbicacion
          onDireccionChange={handleOrigenChange}
          initialLatLng={ubicacionRecibida
            ? { lat: ubicacionRecibida.lat, lng: ubicacionRecibida.lng }
            : datosOrigen
              ? { lat: datosOrigen.lat, lng: datosOrigen.lng }
              : undefined}
          whatsAppProps={{ esperandoSMS, telefono: captura.telefono, onEnviar: enviarWhatsApp }}
        />
      </Modal>

      {/* Modal Destino */}
      {requiereDestino && (
        <Modal
          title={<Space><AimOutlined /><span>Seleccionar Ubicación de Destino</span></Space>}
          open={modalDestinoVisible}
          onCancel={() => setModalDestinoVisible(false)}
          footer={null}
          width={800}
          destroyOnClose
        >
          <MapaUbicacion
            onDireccionChange={handleDestinoChange}
            initialLatLng={datosDestino ? { lat: datosDestino.lat, lng: datosDestino.lng } : undefined}
            mostrarTalleres={esGS}
          />
        </Modal>
      )}
    </div>
  );
};